// This is recursive: it traverses a parent branch all the way down
// It only works from root to leaves
export function selectGroups(groups = [], groupPath = "") {
  const pathItems = groupPath.split("/").filter((el) => !!el);

  const firstPathItem = pathItems.shift();
  const firstLevel = groups.find((g) => g.name === firstPathItem);

  if (!firstLevel) {
    return [];
  }

  const selected = [firstLevel.name];

  let currentGroup = firstLevel;
  let pathItem = pathItems.shift();

  // Let's find the last branch matching the given path
  while (currentGroup && pathItem) {
    const foundGroup = firstLevel.children.find((g) => g.name === pathItem);

    if (foundGroup) {
      selected.push(foundGroup.name);
      currentGroup = foundGroup;
    }

    pathItem = pathItems.shift();
  }

  // And add its leaves to the selected nodes
  selected.push(
    ...currentGroup.children.flatMap(function traverse(d) {
      if (!d.children) {
        return [d.name, ...(d.includes || [])];
      } else {
        return [d.name, ...d.children.flatMap(traverse)];
      }
    })
  );

  return new Set(selected);
}
